import React, { useEffect } from 'react'
import env from '../../../Config'
import './mobileStyles.scss'

const MobileDevelopment = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className='container-fluid base-pad pt-0'>
      <div className=''>
        <img src={env.baseUrl + '/images/mobile-app.jpg'} className='img-fluid' />
      </div>
      <div>
        <div className='navibluebox-row'>
          <div className='bigcol'>
            <h6 class="sec-heading text-uppercase">Mobile App</h6>
            <h2 className='base-h1'> Mobile App Development services</h2>
            <p>
              At <strong>CodexCore</strong>, we deliver professional mobile app development services that help businesses connect with customers, improve operations, and drive digital growth. We build fast, secure, scalable, and user-friendly mobile applications that provide seamless experiences across iOS and Android devices. From startups to established businesses, we transform ideas into powerful mobile solutions tailored to your specific goals and audience.
            </p>
            <p>
              Our experienced mobile app developers use modern technologies and proven development practices to create high-performing applications with intuitive UI/UX, reliable functionality, and strong security. From concept and design to development, testing, deployment, and ongoing support, we manage the complete app development lifecycle. Whether you need a business app, e-commerce app, custom mobile application, or scalable enterprise solution, CodexCore helps you build mobile experiences that engage users and deliver measurable business value.
            </p>
            <h3>Our Mobile App Development Services Offer</h3>
            <div className='d-lg-flex d-md-flex justify-content-between'>
              <ul>
                <li className='py-2'>Custom App Development</li>
                <li className='py-2'>Cross-Platform Development</li>
                <li className='py-2'>Native App Development</li>
              </ul>
              <ul>
                <li className='py-2'>UI/UX Design</li>
                <li className='py-2'>Testing and Quality Assurance</li>
              </ul>
            </div>

          </div>
          <div className='smallcol minus'>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/custom-web.png'} className='img-fluid' />
                </div>
                <h4>Custom App Development</h4>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/e-commerce.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>Cross-Platform Development</h4>
                </div>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/responsive.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>Native App Development</h4>
                </div>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/cms.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>UI/UX Design</h4>
                </div>
              </div>
            </div>
            <div className='icon-row'>
              <div className='box'>
                <div className='custom-web-icon'>
                  <img src={env.baseUrl + '/images/support.png'} className='img-fluid' />
                </div>
                <div>
                  <h4>Testing and Quality Assurance</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-white sec-pad'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1'>
              <img src={env.baseUrl + '/images/custom-mobile-app.jpg'} className='img-fluid img-cust' />
            </div>
            <div className='col-lg-6 order-lg-2'>
              <div className='r-box'>
                <h3> Custom App Development</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>Turn your ideas into powerful digital solutions with CodexCore’s custom app development services. We build tailored mobile applications designed around your business goals, target audience, and unique requirements. Whether you need a customer-facing mobile app, an enterprise application, or an industry-specific solution, our team combines modern technology, intuitive design, and scalable development practices to deliver apps that are reliable, secure, and easy to use.</p>
                </div>
                <div>
                  <h4>Our Custom App Development Process</h4>
                  <ul>
                    <li>Discovery and Requirements Analysis</li>
                    <li>UI/UX Design</li>
                    <li>Development and Testing</li>
                    <li>Deployment and Support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-light '>
        <div className='container sec-pad'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1 d-none d-lg-block'>
              <div className='l-box'>
                <h3> Cross-Platform Development</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    Reach more users with CodexCore’s cross-platform app development services. We build high-quality mobile applications that work seamlessly across iOS and Android using a shared codebase, helping businesses reduce development time and costs while maintaining a consistent user experience. Our experienced developers use modern frameworks and proven development practices to create fast, scalable, secure, and reliable apps tailored to your business requirements.
                  </p>
                </div>
                <div>
                  <h4>Our Cross-Platform Development Services Offer</h4>
                  <ul>
                    <li>React Native Development</li>
                    <li>Flutter Development</li>
                    <li>Ionic Development</li>
                    <li>Cross-Platform Testing and Optimization</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='col-lg-6 order-lg-2 d-none d-lg-block'>
              <img src={env.baseUrl + '/images/cross-platform.jpg'} className='img-fluid' />
            </div>
            <div className='col-lg-6 d-block d-lg-none'>
              <img src={env.baseUrl + '/images/cross-platform.jpg'} className='img-fluid' />
            </div>
            <div className='col-lg-6 d-block d-lg-none'>
              <div className='l-box'>
                <h3> Cross-Platform Development</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>Cross-platform development is a versatile approach to mobile app development that enables businesses to create applications that run seamlessly across multiple platforms, such as iOS and Android, using a single codebase. At  CodexCore( CodexCore), we specialize in cross-platform development solutions that offer cost-effectiveness, efficiency, and broad reach without compromising on performance or user experience. Our team of experienced developers leverages leading cross-platform frameworks to build high-quality apps that meet your specific business requirements and objectives.</p>
                </div>
                <div>
                  <h4>Our Cross-Platform Development Services Offe</h4>
                  <ul>
                    <li>React Native Development</li>
                    <li>Flutter Development</li>
                    <li>Ionic Development</li>
                    <li>Cross-Platform Testing and Optimization</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className='sec-pad'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1 d-lg-block'>
              <img src={env.baseUrl + '/images/native.jpg'} className='img-fluid img-cust' />
            </div>
            <div className='col-lg-6 order-lg-2 d-lg-block'>
              <div className='r-box'>
                <h3>Native App Development</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    Get the best performance and user experience with CodexCore’s native app development services. We build high-performance mobile applications specifically for iOS and Android, using platform-specific technologies to take full advantage of each operating system’s features and capabilities. Our native apps are designed for speed, security, reliability, and seamless user experiences, making them ideal for businesses that require powerful and feature-rich mobile solutions.
                  </p>
                </div>
                <div>
                  <h4>Our Approach to Native App Development</h4>
                  <ul>
                    <li>Platform-Specific Development</li>
                    <li>User-Centric Design</li>
                    <li>Agile Development Methodology</li>
                    <li>Thorough Testing and Quality Assurance</li>
                    <li>Deployment and Maintenance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='sec-pad bg-light'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 order-lg-1 d-none d-lg-block'>
              <div className='l-box'>
                <h3>UI/UX Design</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>
                    At CodexCore, we create intuitive and engaging UI/UX designs that make digital products easy to use, visually appealing, and enjoyable for your users. Our design process combines user research, creative thinking, and modern design principles to build experiences that align with your brand and business objectives. From websites and mobile apps to custom digital products, we design interfaces that improve usability, strengthen brand identity, and encourage user engagement.
                  </p>
                </div>
                <div>
                  <h4>Our Approach to UI/UX Design</h4>
                  <ul>
                    <li>User Research and Analysis</li>
                    <li>Wireframing and Prototypin</li>
                    <li>Visual Design and Branding</li>
                    <li>Usability Testing and Iteration</li>
                    <li>Responsive Design</li>
                  </ul>
                </div>
              </div>

            </div>
            <div className='col-lg-6 order-lg-2 d-none d-lg-block'>
              <img src={env.baseUrl + '/images/ui-ux.jpg'} className='img-fluid' />
            </div>
            <div className='col-lg-6 d-block d-lg-none'>
              <img src={env.baseUrl + '/images/ui-ux.jpg'} className='img-fluid' />
            </div>
            <div className='col-lg-6 d-block d-lg-none'>
              <div className='l-box'>
                <h3>UI/UX Design</h3>
                <div className='d-flex justify-content-center align-items-center'>
                  <p>UI/UX design plays a pivotal role in the success of digital products by focusing on creating intuitive, user-friendly interfaces and delightful user experiences. At  CodexCore( CodexCore), we specialize in UI/UX design solutions that combine creativity, empathy, and technical expertise to craft visually stunning and highly functional interfaces that resonate with users and drive engagement. Our team of talented designers is dedicated to delivering exceptional UI/UX design services tailored to your specific business goals and target audience.</p>
                </div>
                <div>
                  <h4>Our Approach to UI/UX Design</h4>
                  <ul>
                    <li>User Research and Analysis</li>
                    <li>Wireframing and Prototypin</li>
                    <li>Visual Design and Branding</li>
                    <li>Usability Testing and Iteration</li>
                    <li>Responsive Design</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileDevelopment